.linkChip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border-radius: 9999px;
    font-size: var(--mantine-font-size-sm);
    text-decoration: none;
    cursor: pointer;
    transition: background-color 0.15s ease, box-shadow 0.15s ease;

    &.filled {
        background-color: var(--dib-brand-base);
        color: #fff;

        &:hover {
            background-color: color-mix(in srgb, var(--dib-brand-base) 90%, white);
        }
    }

    &.outlined {
        background-color: transparent;
        color: var(--dib-ink);
        box-shadow: inset 0 0 0 1px var(--dib-ink);

        &:hover {
            background-color: color-mix(in srgb, var(--dib-surface) 50%, transparent);
        }
    }
}

.leftSection {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    & > svg {
        width: 14px;
        height: 14px;
    }
}

.chevron {
    display: flex;
    align-items: center;

    & > svg {
        width: 16px;
        height: 16px;
        transform: translateY(1px);
    }
}
